import { Component, Signal, ChangeDetectionStrategy } from '@angular/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { SidenavComponent } from '../../components/sidenav/sidenav.component';
import { RouterModule } from '@angular/router';
import { MasqueradeHeaderComponent } from '../../components/masquerade-header/masquerade-header.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { AsyncPipe } from '@angular/common';
import { LoadingService } from '../../../core/services/loading/loading.service';
import { UserStateService } from '../../../modules/user/shared/services/user-state/user-state.service';

@Component({
    selector: 'app-base-layout',
    templateUrl: './base-layout.component.html',
    styleUrls: ['./base-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FooterComponent,
        HeaderComponent,
        SidenavComponent,
        RouterModule,
        MasqueradeHeaderComponent,
        LoadingComponent,
        AsyncPipe,
    ],
})
export class BaseLayoutComponent {
    loading$ = this.loadingService.loading$;
    isMasqueraded: Signal<boolean> = this.userStateService.isMasqueraded;

    constructor(
        private readonly loadingService: LoadingService,
        private readonly userStateService: UserStateService,
    ) {}
}
